import { module } from 'modujs';
import { $html } from '../utils/dom';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.hide()
    }

    hide() {
        requestAnimationFrame(() => {
            for(let classToAdd of ['is-loaded', 'is-first-load', 'is-ready']) {
                $html.classList.add(classToAdd);
            }
            $html.classList.remove('is-loading');
        });
    }
}
